/* tslint:disable */
import { Store } from '@souche-f2e/muji';
const modules = {
    'global': require('../stores/global.ts').default,
    'menu': require('../stores/menu.ts').default,
    'setting': require('../stores/setting.ts').default
};
const storeConfig = {
    initialState: window['@@muji@storeInitialState'] || {},
    modules,
};
const store = new Store(storeConfig);
export default store;
export const { dispatch, getState } = store;
if (module.hot) {
    // save current state before module being reloaded
    module.hot.dispose(() => window['@@muji@storeInitialState'] = store.getState());
    module.hot.accept(['../stores/global.ts'], () => {
        store.mount('global', require('../stores/global.ts').default);
    });
    module.hot.accept(['../stores/menu.ts'], () => {
        store.mount('menu', require('../stores/menu.ts').default);
    });
    module.hot.accept(['../stores/setting.ts'], () => {
        store.mount('setting', require('../stores/setting.ts').default);
    });
}
